import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import './AgentsOverlay.scss';
import Chart from 'chart.js/auto';

const AgentsOverlay = ({ data, response }) => {

    const chartRef = useRef(null);

    AgentsOverlay.propTypes = {
        response: PropTypes.any,
        data: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string.isRequired,
                collectedAmount: PropTypes.string.isRequired,
                workedAccounts: PropTypes.number.isRequired,
                actionsTaken: PropTypes.string.isRequired
            })
        ).isRequired
    }

    useEffect(() => {
        if (data && data.length && chartRef.current) {
            const ctx = chartRef.current.getContext('2d');

            // Extract labels and values from the data
            const labels = Array.isArray(response) ? response.map((agent) => agent.product) : [];
            const values = Array.isArray(response) ? response.map((agent) => agent.users) : [];


            const colors = [
                'rgba(133, 113, 244, 1)',
                'rgba(9, 114, 121, 1)',
                'rgba(48, 206, 216, 1)',
                'rgba(76, 214, 180, 1)',
                'rgba(131, 60, 202, 1)',
                'rgba(30, 156, 164, 1)'
            ];

            // Create pie chart
            const myChart = new Chart(ctx, {
                type: 'pie',
                data: {
                    labels,
                    datasets: [
                        {
                            data: values,
                            backgroundColor: [
                                'rgba(133, 113, 244, 1)',
                                'rgba(9, 114, 121, 1)',
                                'rgba(48, 206, 216, 1)',
                                'rgba(76, 214, 180, 1)',
                                'rgba(131, 60, 202, 1)',
                                'rgba(30, 156, 164, 1)'
                            ],
                            borderColor: [
                                'rgba(133, 113, 244, 1)',
                                'rgba(9, 114, 121, 1)',
                                'rgba(48, 206, 216, 1)',
                                'rgba(76, 214, 180, 1)',
                                'rgba(131, 60, 202, 1)',
                                'rgba(30, 156, 164, 1)'
                            ],
                            borderWidth: 1
                        },
                    ],
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        tooltip: {
                            callbacks: {
                                label: function (context) {
                                    return context.label + ': ' + context.formattedValue;
                                }
                            }
                        },
                        legend: {
                            display: false
                        }
                    }
                }
            });
            const legend = document.getElementById('legend');

            legend.innerHTML = '';

            if (legend) {
                labels?.forEach((label, index) => {
                    const li = document.createElement('li');
                    li.textContent = `${label}`; // Display label with percentage
                    li.classList.add('amount-modal'); // Add your class name here
                    li.style.color = colors[index % colors.length]; // Set text color to white
                    li.style.listStyleType = 'none'; // Remove default bullet style
                    legend.appendChild(li);

                    // Create a span element for the bullet
                    const bullet = document.createElement('span');
                    bullet.textContent = ''; // No text content needed
                    bullet.classList.add('bullet'); // Add a class for styling
                    bullet.style.borderColor = colors[index % colors.length]; // Set border color
                    li.insertBefore(bullet, li.firstChild); // Insert the bullet before the text content
                });
            }
            return () => {
                myChart.destroy();
            };
        }

    }, [data, response]);

    return (
        <>
            <div className="agent_overlay_container">
                <div className='overlay_table_container'>
                    <div id='agent_overlay_header'>
                        <h3>Agents</h3>
                    </div>
                    <div className="agent_overlay_table">
                        <div className="overlay_table_row overlay_table_header">
                            <p className='overlay_heading'>Name</p>
                            <p className='overlay_heading'>Collected Amount</p>
                            <p className='overlay_heading'>Worked Accounts</p>
                            <p className='overlay_heading'>Actions Taken</p>
                        </div>
                        <div>
                            {data?.map((agent, index) => (
                                <div className="overlay_table_row" key={index}>
                                    <p>{agent.name}</p>
                                    <p>{agent.collectedAmount}</p>
                                    <p>{agent.workedAccounts}</p>
                                    <p>{agent.actionsTaken}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className='agents-pie'>
                    <canvas ref={chartRef}></canvas>
                </div>
                <ul id="legend" className='legend'></ul>
            </div>
        </>

    );

};

export default AgentsOverlay;
